import { Component, OnInit } from '@angular/core';
import { AutotextService } from 'src/app/autotext.service';
import { ExamsService } from 'src/app/exams.service';
import { UsgService } from 'src/app/usg.service';

@Component({
    selector: 'app-findings',
    templateUrl: './findings.component.html',
    styleUrls: ['./findings.component.scss'],
    standalone: false
})
export class FindingsComponent implements OnInit {


  constructor(public gs:UsgService, public atS:AutotextService, public es:ExamsService) { }

  ngOnInit() {
  }

}
